import { render, staticRenderFns } from "./SubmitSuccess.vue?vue&type=template&id=2901b0dc&scoped=true"
import script from "./SubmitSuccess.vue?vue&type=script&lang=ts"
export * from "./SubmitSuccess.vue?vue&type=script&lang=ts"
import style0 from "./SubmitSuccess.vue?vue&type=style&index=0&id=2901b0dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2901b0dc",
  null
  
)

export default component.exports